import "./App.css";
import Home from './Screen/Home';
import About from './Screen/About';
import Hosue from './Screen/House';
import Land from './Screen/Land';
import Office from "./Screen/Office";
import Shop from "./Screen/Shop";
import Insurance from "./Screen/Insurance";
import Contact from './Screen/Contact';
import REFUNDPOLICY from './Screen/refundpolicy';
import PrivacyPolicy from "./Screen/privacypolicy";
import TermsConditions from './Screen/TermsConditions';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <>    <Router>
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/House" element={<Hosue/>} />
          <Route path="/Land" element={<Land />} />
          <Route path="/Office" element={<Office />} />
          <Route path="/Shop" element={<Shop />} />
          <Route path="/Insurance" element={<Insurance />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/refundpolicy" element={<REFUNDPOLICY/>} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsConditions" element={<TermsConditions />} />
          
        </Routes>
      </div>
    </Router>

    <section>
    <a href="tel:+919884226561" class="fixed-call-button">
        <i class="fas fa-phone-alt phone-icon"></i>
    </a>
</section>  


</>


  );
}

export default App;
